<!--
    Summary:
        人才招募
    ChangeLog:
        Labbor on 2020/2/21 added
-->
<template>
    <div class="v-career">
      <banner>
        <img src="../../assets/images/about/Header_1920x380_career.jpg"/>
        <div slot="title">{{$t('Career.Title')}}</div>
      </banner>

      <!-- 我们深明检测准确的重要性 -->
      <card>
        <div slot="title">{{$t('Career.P1Title')}}</div>

        <el-collapse accordion>
          <el-collapse-item v-for="(job,index) in jobs" :key="index">
            <template slot="title">
              <i class="icon-xiguan iconfont"></i>
              <h4 class="h4 job-name">{{job.name}}</h4>
            </template>

            <div class="responsibility">
              <div class="title2">
                <p style="font-size: 18px; color: #368da7;"><strong>{{$t('Career.P1Title2')}}</strong></p>
              </div>
              <div class="item" v-for="(r,index) in job.responsibility" :key="index">
                <i class="icon-selected iconfont"></i>
                <p class="p">{{r}}</p>
              </div>
            </div>
            <div class="experience">
              <div class="title2">
                <p style="font-size: 18px; color: #368da7;"><strong>{{$t('Career.P1Title3')}}</strong></p>
              </div>
              <div class="item" v-for="(r,index) in job.experience" :key="index">
                <i class="icon-selected iconfont"></i>
                <p class="p">{{r}}</p>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>

      <div class="addon">
        <p class="p">{{$t('Career.P2Detail')}}</p>
        <p class="p">{{$t('Career.P2Detail2')}}</p>
      </div>
    </div>
</template>

<script>
  import banner from '@/components/banner'
  import card from '@/components/card'
  import hoverBox from '@/components/hover-box'

  export default {
    components: {
      banner,
      card,
      hoverBox
    },
    data() {
      return {
        jobs:[
          {
            name:'Laboratory Technician / Assistant',
            responsibility:[
              "Perform all initial specimen preparation.",
              "Perform housekeeping duties at the laboratory.",
              "Assist the Admin Officer to perform general clerical duties.",
              "Perform any laboratory duties assigned by the Medical Technologist and Lab Manager.",
              "Participate in-house and external training as required.",
              "Other ad-hoc duties are also required.",
            ],
            experience:[
            "Bachelor's Degree or Higher Diploma in Biomedical Science or other related Life Science disciplines.",
            "Experience in genetic/ DNA analysis, including DNA extraction, sequencing, PCR etc. is preferable.",
            "Responsible and hard working with good initiatives.",
            "Must be a good team player with excellent communication skills as well as be able to work independently.",
            "To be able to communicate with Cantonese, Mandarin and English.",
            "Good PC knowledge and typing skill is essential.",
            "Night shift is required (not overnight shift, 15:00 - 24:00 / 17:00 - 02:00, taxi fee will be provided for night shift staff).",
          ]
          },
          {
            name:'Administrative Assistant',
            responsibility:[
              "To check and verify clients' information on request form.",
              "To print reports and ensure all results and clients' information are correct before sending out.",
              "To maintain good communication with clinics for daily administration work.",
              "To update and maintain filings and database systematically and consistently..",
              "To assist in answering phone calls.",
              "To handle ad-hoc duties as assigned.",
            ],
            experience:[
              "Diploma level.",
              "Strong sense of responsibility and detail-minded.",
              "Willing to learn and able to work under pressure independently in a fast-pace environment, sensible on checking clients' information.",
              "Good communication skills and team work spirit.",
              "With hands-on PC knowledge and good typing skills preferred.",
            ]
          },
          {
            name:'Associate Medical Technologist',
            responsibility:[
              "Perform reception, handling, processing, storage and testing of human blood according to the Standard Operation Procedure (SOP).",
              "Analyze and accurately record laboratory data.",
              "Maintain and calibrate of laboratory equipment.",
              "Perform quality control for testing.",
              "Participate in-house and external training as required.",
              "Other ad-hoc duties are also required.",
            ],
            experience:[
              " Valid Medical Laboratory Technologist Part I / II practicing certificate issued by the HKMLT Board.",
              "Bachelor Degree or HTC in Biomedical Science, Medical Laboratory Sciences other related disciplines.",
              "Experience in genetic/ DNA analysis, including DNA extraction, sequencing, PCR etc. is preferable.",
              "Strong sense of responsibility.",
              "Must be a good team worker with excellent communication as well as be able to work independently.",
              "To be able to communicate with Mandarin and English.",
              "Night shift is required (not overnight shift, 15:00 - 24:00 / 17:00 - 02:00, taxi fee will be provided for night shift staff).",
            ]
          },
          {
            name:'R&D Officer',
            responsibility:[
              "The candidate will be responsible for existing and new product development of First Choice.",
              "To explore new product development concept.",
              "Research for the information of new product and new product implementation.",
              "Fine-tune existing product.",
              "Prepare and maintain related documentations.",
              "Maintain the website of First Choice.",
              "Assist the R&D manager to call meeting.",
              "Other ad-hoc duties are required.",
            ],
            experience:[
              "Degree holder or above in Biomedical Science or Life Science or related disciplines.",
              "Have a strong sense in new technology development.",
              "3 years of relevant experience, candidates with less related experience will be considered as R&D Assistant.",
              "Have good computer skills, especially in MS Word, Excel, PowerPoint and web designing programs.",
              "Able to work under pressure and meet tight timeline.",
              "Good team player with positive attitude.",
              "Strong interpersonal and negotiation skill.",
              "Good command of written and spoken English and Chinese (both Cantonese and Mandarin).",
            ]
          },
        ],

      }
    },
    methods: {},
  }
</script>

<style>
  .v-career .el-collapse-item__header{
    font-size: 20px;
    height: 67px;
    color: #368da7;
  }
  .v-career .el-collapse{
    border-top: none;
    border-bottom: none;
  }
  .v-career .el-collapse>:last-child .el-collapse-item__header{
    border-bottom: none;
  }
  .v-career .el-collapse-item__header:hover{
    background-color: #51cedd;
    color: #fff;
  }
  .v-career .el-collapse-item__header.is-active{
    background-color: #51cedd;
    color: #fff;
  }
  .v-career .responsibility{
    padding-top: 20px;
    margin-bottom: 20px;
  }
</style>
<style scoped lang="scss">
    .v-career {
      text-align: left;

      .addon{
        text-align: center;
        padding: 30px 0 60px;
      }

      .item{
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .experience{}
      }
      .icon-xiguan{
        font-size: 26px !important;
        margin: 0 15px;
        &:before{
          content: "\f1fb";
        }
      }
      .icon-selected{
        font-size: 18px !important;
        margin-left: 5px;
        margin-right: 15px;
        color: #368da7;
        &:before{
          content: "\f046";
        }
      }
      .iconfont{
        background: 0 0;
        border: 0;
        text-align: center;
        border-radius: 2em;
        display: inline-block;
        font: normal normal normal 14px/1 awesome;
      }
    }
</style>



// WEBPACK FOOTER //
// src/view/about/career.vue